<template>
  <div v-if="deviceDid">
    <el-tabs v-model="activeName" @tab-click="tabClick">
      <el-tab-pane label="3gwan1" name="3gwan1" v-if="Wan3GSwitch">
        <three-wan :data="data" :networkInfo="networkInfo" :WatchData="WatchData" :loading="loading"
          :deviceSoftwareVer="deviceSoftwareVer" @updateWan="updateWan">
        </three-wan>
      </el-tab-pane>
      <el-tab-pane label="3gwan2" name="3gwan2" :lazy="true" v-if="Wan3GTwoSwitch">
        <three-wan :data="data" :networkInfo="networkInfo" :WatchData="WatchData" :loading="loading"
          @updateWan="updateWan" :deviceSoftwareVer="deviceSoftwareVer">
        </three-wan>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import ThreeWan from "./components/ThreeWan/index";
import {
  updateConfig,
  listConfig,
  getNetworkInfo,
} from "@/api/configurationlist";
import { cloneDeep } from "lodash";
import { compareVersion } from "@/utils/Date";
export default {
  props: ["deviceDid", "deviceSn", "Wan3GSwitch", "Wan3GTwoSwitch", "deviceSoftwareVer"],
  components: {
    ThreeWan,
  },
  data() {
    return {
      activeName: "3gwan1",
      data: {},
      WatchData: {},
      loading: true,
      // 网络接口基本信息
      networkInfo: {},
      timer: null,
      simmode: "1",
    };
  },
  watch: {
    deviceSn: {
      immediate: true,
      handler(newValue, oldValue) {
        this.activeName = "3gwan1";
      },
    },
  },
  mounted() {
    this.timer = null;
    this.getConfig();
    this.fetchNetworkInfo();
  },
  activated() {
    this.fetchNetworkInfo();
    this.timer = setInterval(() => {
      this.fetchNetworkInfo();
    }, 10000);
  },
  deactivated() {
    clearInterval(this.timer);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    tabClick(tab) {
      clearInterval(this.timer);
      this.fetchNetworkInfo();
      this.getConfig();
    },
    // 获取设备配置信息
    getConfig() {
      if (this.activeName === "3gwan1") {
        this.getOneConfig();
      } else if (this.activeName === "3gwan2") {
        this.getTwoConfig();
      }
    },
    // 获取3gwan1的配置信息
    getOneConfig() {
      this.loading = true;
      console.log(compareVersion(this.deviceSoftwareVer, "v3.0"));
      
      listConfig(this.deviceSn, this.deviceDid, [
        {
          section: (compareVersion(this.deviceSoftwareVer, "v2.7") != -1) ? "system" : "initconfig",
          config: (compareVersion(this.deviceSoftwareVer, "v2.7") != -1) ? "ciot" : "system",
          options: [{ option: "hardware_class" }],
        },
      ]).then((res) => {
        let h = res.data.data.mess[0].s_objects[0].options.hardware_class;
        if (h.indexOf("SMSC") != -1) {
          this.simmode = 1
        } else if (h.indexOf("SMDC") != 2) {
          this.simmode = 2
        } else if (h.indexOf("DMDC") != -1) {
          this.simmode = 2
        }
        if (this.simmode != 0) {
          listConfig(this.deviceSn, this.deviceDid, [
            {
              section: (compareVersion(this.deviceSoftwareVer, "v3.0") != -1) ? "mnet1" : "3gwan1",
              config: (compareVersion(this.deviceSoftwareVer, "v3.0") != -1) ? "watchfox" : "network",
              options: [
                { option: "proto" },
                { option: "hostname" },
                { option: "apn" },
                { option: "pincode" },
                { option: "nettype" },
                { option: "username" },
                { option: "password" },
                { option: "pppd_options" },
                { option: "icmpenable" },
                { option: "service" },
                { option: "dialnumber" },
                { option: "local_IP_address" },
                { option: "sim_mode" },
                { option: "smartcard" },
                { option: "rebootsys" },
                { option: "smartenable" },
                { option: "defcfg" },
                { option: `sim${this.simmode}_apn` },
                { option: `sim${this.simmode}_user` },
                { option: `sim${this.simmode}_pwd` },
                { option: `sim${this.simmode}_authtype` },
                { option: `sim${this.simmode}_ipaddr` },
                { option: `sim${this.simmode}_pin` },
                { option: `sim${this.simmode}_type` },
                { option: `sim${this.simmode}_policy` },
                { option: `sim${this.simmode}_rthreshold` },
                { option: `sim${this.simmode}_pinghosts` },
                { option: `sim${this.simmode}_pinterval` },
                { option: `sim${this.simmode}_pingcount` },
                { option: `sim${this.simmode}_dthreshold` },
                { option: `sim${this.simmode}_carrierm` },
                { option: `sim${this.simmode}_ipproto` },
              ],
            },
          ])
            .then((res) => {
              this.data = res.data.data.mess[0].s_objects[0].options;
              if (this.data.nettype == "") {
                this.data.nettype = "0";
              }
              if (this.data.icmpenable == "") {
                this.data.icmpenable = "0";
              }
              if (this.data.pppd_options == "") {
                this.data.pppd_options = "0";
              }
              if (this.data.hostname == "") {
                this.data.hostname = "M2M";
              }
              if (this.data[`sim${this.simmode}_carrierm`] == "") {
                this.data[`sim${this.simmode}_carrierm`] = "0";
              }
              if (this.data.smartenable == "") {
                this.data.smartenable = "0"
              }
              this.WatchData = cloneDeep(this.data);
              this.timer = setInterval(() => {
                this.fetchOneNetworkInfo();
              }, 10000);
              this.loading = false;
            })
            .catch((err) => {
              this.$message({
                message: this.$t("lang.request.timeout"),
                type: "warning",
              });
            });
        } else {
          listConfig(this.deviceSn, this.deviceDid, [
            {
              section: (compareVersion(this.deviceSoftwareVer, "v3.0") != -1) ? "mnet1" : "3gwan1",
              config: (compareVersion(this.deviceSoftwareVer, "v3.0") != -1) ? "watchfox" : "network",
              options: [
                { option: "proto" },
                { option: "hostname" },
                { option: "apn" },
                { option: "pincode" },
                { option: "nettype" },
                { option: "username" },
                { option: "password" },
                { option: "pppd_options" },
                { option: "icmpenable" },
                { option: "service" },
                { option: "dialnumber" },
                { option: "local_IP_address" },
                { option: "sim_mode" },
                { option: "smartcard" },
                { option: "rebootsys" },
                { option: "smartenable" },
                { option: `sim2_apn` },
                { option: `sim1_apn` },
                { option: `sim2_user` },
                { option: `sim1_user` },
                { option: `sim2_pwd` },
                { option: `sim1_pwd` },
                { option: `sim2_authtype` },
                { option: `sim1_authtype` },
                { option: `sim2_ipaddr` },
                { option: `sim1_ipaddr` },
                { option: `sim2_pin` },
                { option: `sim1_pin` },
                { option: `sim2_type` },
                { option: `sim1_type` },
                { option: `sim2_policy` },
                { option: `sim1_policy` },
                { option: `sim2_rthreshold` },
                { option: `sim1_rthreshold` },
                { option: `sim2_pinghosts` },
                { option: `sim1_pinghosts` },
                { option: `sim2_pinterval` },
                { option: `sim1_pinterval` },
                { option: `sim2_pingcount` },
                { option: `sim1_pingcount` },
                { option: `sim2_dthreshold` },
                { option: `sim1_dthreshold` },
                { option: `sim1_carrierm` },
                { option: `sim2_carrierm` },
                { option: 'sim1_defcfg' },
                { option: 'sim2_defcfg' },
                { option: `sim1_ipproto` },
                { option: `sim2_ipproto` },
              ],
            },
          ])
            .then((res) => {
              this.data = res.data.data.mess[0].s_objects[0].options;
              // if (this.data.sim_mode == "") {
              //   this.data.sim_mode = "1"
              // }
              if (this.data.sim1_authtype == "") {
                this.data.sim1_authtype = "2"
              }
              if (this.data.sim1_type == "") {
                this.data.sim1_type = "0"
              }
              if (this.data.sim1_policy == "") {
                this.data.sim1_policy = "0"
              }
              if (this.data.smartenable == "") {
                this.data.smartenable = "0"
              }
              if (this.data.rebootsys == "") {
                this.data.rebootsys = "1"
              }
              if (this.data.sim1_dthreshold == "") {
                this.data.sim1_dthreshold = "500"
              }
              if (this.data.sim1_pinterval == "") {
                this.data.sim1_pinterval = "60"
              }
              if (this.data.sim1_pingcount == "") {
                this.data.sim1_pingcount = "3"
              }
              if (this.data.nettype == "") {
                this.data.nettype = "0";
              }
              if (this.data.icmpenable == "") {
                this.data.icmpenable = "0";
              }
              if (this.data.pppd_options == "") {
                this.data.pppd_options = "0";
              }
              if (this.data.hostname == "") {
                this.data.hostname = "M2M";
              }
              if (this.data.sim2_carrierm == "") {
                this.data.hostname = "0";
              }
              if (this.data.sim1_carrierm == "") {
                this.data.hostname = "0";
              }
              this.WatchData = cloneDeep(this.data);
              this.timer = setInterval(() => {
                this.fetchOneNetworkInfo();
              }, 10000);
              this.loading = false;
            })
            .catch((err) => {
              this.$message({
                message: this.$t("lang.request.timeout"),
                type: "warning",
              });
            });
        }
      });
    },
    // 获取3wan2的配置信息
    getTwoConfig() {
      this.loading = true;
      listConfig(this.deviceSn, this.deviceDid, [
        {
          section: (compareVersion(this.deviceSoftwareVer, "v3.0") != -1) ? "mnet2" : "3gwan1",
          config: (compareVersion(this.deviceSoftwareVer, "v3.0") != -1) ? "watchfox" : "network",
          options: [
            { option: "proto" },
            { option: "hostname" },
            { option: "apn" },
            { option: "pincode" },
            { option: "nettype" },
            { option: "username" },
            { option: "password" },
            { option: "pppd_options" },
            { option: "icmpenable" },
            { option: "service" },
            { option: "dialnumber" },
            { option: "defcfg" },
            { option: "local_IP_address" },
            { option: "sim_mode" },
            { option: "sim2_apn" },
            { option: "sim2_user" },
            { option: "sim2_pwd" },
            { option: "sim2_authtype" },
            { option: "sim2_ipaddr" },
            { option: "sim2_pin" },
            { option: "sim2_type" },
            { option: "sim2_policy" },
            { option: "sim2_rthreshold" },
            { option: "rebootsys" },
            { option: "smartenable" },
            { option: "smartcard" },
            { option: "sim2_pinghosts" },
            { option: "sim2_pinterval" },
            { option: "sim2_pingcount" },
            { option: "sim2_dthreshold" },
            { option: "sim2_dthreshold" },
            { option: `sim2_ipproto` },
          ],
        },
      ])
        .then((res) => {
          this.data = res.data.data.mess[0].s_objects[0].options;
          if (this.data.nettype == "") {
            this.data.nettype = "0";
          }
          if (this.data.pppd_options == "") {
            this.data.pppd_options = "0";
          }
          if (this.data.icmpenable == "") {
            this.data.icmpenable = "0";
          }
          if (this.data.hostname == "") {
            this.data.hostname = "M2M";
          }
          this.WatchData = cloneDeep(this.data);
          this.timer = setInterval(() => {
            this.fetchTwoNetworkInfo();
          }, 10000);
          this.loading = false;
        })
        .catch((err) => {
          this.$message({
            message: this.$t("lang.request.timeout"),
            type: "warning",
          });
        });
    },
    // 获取网络信息
    fetchNetworkInfo() {
      clearInterval(this.timer);
      if (this.activeName === "3gwan1") {
        this.fetchOneNetworkInfo();
      } else if (this.activeName === "3gwan2") {
        this.fetchTwoNetworkInfo();
      }
    },
    // 获取3gwan1接口网络信息
    fetchOneNetworkInfo() {
      getNetworkInfo(this.deviceDid, this.deviceSn, ["3gwan1"]).then((res) => {
        this.networkInfo = res.data.data.mess["3gwan1"];
      });
    },
    // 获取3gwan2接口网络信息
    fetchTwoNetworkInfo() {
      getNetworkInfo(this.deviceDid, this.deviceSn, ["3gwan2"]).then((res) => {
        this.networkInfo = res.data.data.mess["3gwan2"];
      });
    },
    // 更新数据
    updateWan(updateData) {
      clearInterval(this.timer);
      //提交修改
      let section = "3gwan1";
      if (this.activeName === "3gwan1") {
        section = "3gwan1";
      } else if (this.activeName === "3gwan2") {
        section = "3gwan2";
      }
      updateConfig(this.deviceSn, this.deviceDid, [
        {
          section: section,
          config: "network",
          action: 0,
          index: [0],
          server: "watchfox",
          options: {
            ...updateData,
          },
        },
      ]).then((res) => {
        if (res.data.data.mess === 0) {
          this.$message({
            showClose: true,
            message: this.$t("lang.ConfigSetting.Successfulconfiguration"),
            type: "success",
          });
          this.getConfig();
          this.fetchNetworkInfo();
        } else {
          this.$message({
            showClose: true,
            message: this.$t("lang.ConfigSetting.Configurationerror"),
            type: "warning",
          });
          return;
        }
      });
    },
  },
};
</script>
